import qs from "qs";
import {
  fetchRequest,
  reactQueryGet,
  reactQueryPost,
  serializeJsonResponse,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type {
  PixPrepareResponseEndpoint,
  PrepareRequestEndpoint,
  ShowEndpointQueryParams,
  ShowResponseEndpoint,
  VerificationsCreateParams,
} from "./paywallCheckoutApi.types";

export interface PaywallCheckoutError {
  error_details?: any;
  message: string;
}

const preview = async ({
  queryParams,
  shouldIgnoreCommunityMember,
  locale,
}: any) => {
  const previewUrl = `${internalApi.paywallCheckout.preview()}${qs.stringify({
    checkout: queryParams,
    ...(locale ? { locale } : {}),
  })}`;

  const response = await fetch(previewUrl, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: shouldIgnoreCommunityMember ? "omit" : "same-origin",
  });

  return serializeJsonResponse(response);
};

const prepare = (
  params: PrepareRequestEndpoint,
): Promise<PixPrepareResponseEndpoint> =>
  reactQueryPost(internalApi.paywallCheckout.prepare(), {
    checkout: params,
  });

const create = ({ formData }: any) =>
  reactQueryPost(internalApi.paywallCheckout.create(), {
    checkout: formData,
  });

const prepare_DEPRECATED = (communityId: number, paywallPriceId: number) =>
  fetchRequest<Response>(internalApi.paywallCheckout.prepare(), {
    method: "POST",
    body: JSON.stringify({
      checkout: {
        community_id: communityId,
        paywall_price_id: paywallPriceId,
      },
    }),
  });

const create_DEPRECATED = ({ formData }: any) =>
  fetchRequest<Response>(internalApi.paywallCheckout.create(), {
    method: "POST",
    body: JSON.stringify({ checkout: formData }),
  });

const complete = (checkoutResultData: any) =>
  fetchRequest<Response>(internalApi.paywallCheckout.complete(), {
    method: "POST",
    body: JSON.stringify({ checkout: checkoutResultData }),
  });

const show = (queryParams: ShowEndpointQueryParams) =>
  reactQueryGet<ShowResponseEndpoint>(
    internalApi.paywallCheckout.show({ params: queryParams }),
  );

const verificationsCreate = (params: VerificationsCreateParams) =>
  reactQueryPost(internalApi.paywallCheckout.verifications.create(params));

const attemptShow = (fingerprint: string) =>
  reactQueryGet(internalApi.paywallCheckout.attempts.show(fingerprint));

export const paywallCheckoutApi = {
  preview,
  prepare,
  create,
  prepare_DEPRECATED,
  create_DEPRECATED,
  complete,

  show,

  attempts: {
    show: attemptShow,
  },

  verifications: {
    create: verificationsCreate,
  },
};
